import { useCallback, useState } from 'react';
import { useABTest, type ABVariant } from '@/hooks/useABTest';
import VariantA from './VariantA';
import VariantB from './VariantB';
import VariantC from './VariantC';
import { Settings } from 'lucide-react';

const ABCalculator = () => {
  const { variant, setManualVariant, trackEvent, getAnalytics } = useABTest();
  const [showPanel, setShowPanel] = useState(false);

  const onInteraction = useCallback(() => {
    trackEvent('interaction', { component: 'calculator' });
  }, [trackEvent]);

  const onConversion = useCallback(() => {
    trackEvent('conversion', { component: 'calculator' });
  }, [trackEvent]);

  return (
    <div className="relative">
      {variant === 'A' && <VariantA onInteraction={onInteraction} onConversion={onConversion} />}
      {variant === 'B' && <VariantB onInteraction={onInteraction} onConversion={onConversion} />}
      {variant === 'C' && <VariantC onInteraction={onInteraction} onConversion={onConversion} />}

      {/* Admin toggle — bottom-right corner, small */}
      <div className="fixed bottom-4 left-4 z-50">
        <button
          onClick={() => setShowPanel(!showPanel)}
          className="w-8 h-8 rounded-full bg-muted/80 backdrop-blur border border-border flex items-center justify-center text-muted-foreground hover:text-foreground transition-colors"
          title="A/B Test Panel"
        >
          <Settings className="w-3.5 h-3.5" />
        </button>

        {showPanel && (
          <div className="absolute bottom-10 left-0 bg-card border border-border rounded-xl shadow-xl p-4 w-64 space-y-3">
            <p className="text-xs font-bold text-foreground uppercase tracking-wide">A/B Test Control</p>
            <p className="text-xs text-muted-foreground">Current: <span className="font-bold text-primary">Variant {variant}</span></p>
            <div className="flex gap-2">
              {(['A', 'B', 'C'] as ABVariant[]).map(v => (
                <button
                  key={v}
                  onClick={() => setManualVariant(v)}
                  className={`flex-1 py-1.5 rounded-lg text-xs font-bold transition-all ${
                    variant === v ? 'bg-gradient-gold text-primary-foreground' : 'bg-muted text-muted-foreground hover:bg-primary/10'
                  }`}
                >
                  {v}
                </button>
              ))}
            </div>
            <div className="text-[10px] text-muted-foreground space-y-0.5">
              <p>A = Full Width Hero</p>
              <p>B = Right Side Card</p>
              <p>C = Normal + Sticky</p>
            </div>
            <button
              onClick={() => { console.log('[AB Analytics]', getAnalytics()); }}
              className="w-full py-1.5 rounded-lg bg-muted text-xs text-muted-foreground hover:text-foreground border border-border"
            >
              Log Analytics to Console
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ABCalculator;
